<p-table #dt [value]="affiliations" expandableRows="true" [globalFilterFields]="['affiliateType','endDate','updatedDate','updatedBy']" dataKey="id">
    <ng-template pTemplate="caption">
        <div class="row">
            <div class="col-sm-6 col-md-3">
                <input class="mvd_form-control" type="text" autocomplete="off" placeholder="Filter..." (input)="dt.filterGlobal($event.target.value, 'contains')">
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="5">
                No records found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th class="w--arrow"></th>
            <th>Affiliation Type</th>
            <th class="w--date">End Date</th>
            <th class="w--date">Updated</th>
            <th>Updated By</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-expanded="expanded" let-data>
        <tr [pSelectableRow]="data">
            <td>
                <a href="javascript:void(0)" [pRowToggler]="data">
                    <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                </a>
            </td>
            <td>{{data.affiliateType}}</td>
            <td>{{data.endDate | shortDate}}</td>
            <td>{{data.updatedDate | shortDate}}</td>
            <td>{{data.updatedBy}}</td>
        </tr>
    </ng-template>

    <ng-template pTemplate="rowexpansion" let-data>
        <tr>
            <td [attr.colspan]="5">
                <div class="row">
                    <div class="col-sm-3 mvd_form-group">
                        <label>Customer</label>
                        <div class="mvd_form-control" *ngFor="let member of data.members">{{member.firstName}} {{member.lastName}}</div>
                    </div>
                    <div class="col-sm-3 mvd_form-group">
                        <label>Role</label>
                        <div class="mvd_form-control" *ngFor="let member of data.members">{{member.customerAffiliationRoleTypeDisplayValue}}</div>
                    </div>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>